"use strict";

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/mnt/ephemeral/jenkins/workspace/lucid-co-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.symbol");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarDropdownContext = void 0;
/** @jsx jsx */

var react_1 = require("react");

var core_1 = require("@emotion/core");

var styled_1 = __importDefault(require("../../../theme/styled"));

var navbar_1 = require("./navbar");

var emotion_theming_1 = require("emotion-theming");

var utils_1 = require("../../../utils/utils");

var DropdownWrapper = styled_1.default.div(function () {
  return {
    position: 'relative'
  };
});
var DROPDOWN_SAFETY_TIMER = 225;
exports.NavbarDropdownContext = react_1.createContext({
  isOpen: false,
  displayLeft: false
});
var NavbarDropdown = react_1.forwardRef(function (_a, ref) {
  var theme = _a.theme,
      toggle = _a.toggle,
      children = _a.children,
      rest = __rest(_a, ["theme", "toggle", "children"]);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isOpen = _react_1$useState2[0],
      setIsOpen = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(true),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      displayLeft = _react_1$useState4[0],
      setDisplayLeft = _react_1$useState4[1];

  var _react_1$useContext = react_1.useContext(navbar_1.NavbarContext),
      setActiveDropdownSetIsOpen = _react_1$useContext.setActiveDropdownSetIsOpen;

  var timer;

  var openDropdown = function openDropdown(evt) {
    setIsOpen(true);
    setActiveDropdownSetIsOpen([setIsOpen]);
    var threshold = 400;
    var rect = evt.currentTarget.getBoundingClientRect();
    var diff = document.body.offsetWidth - rect.left;

    if (diff < threshold && displayLeft) {
      setDisplayLeft(false);
    } else if (diff >= threshold && !displayLeft) {
      setDisplayLeft(true);
    }

    clearTimeout(timer);
  };

  var closeDropdown = function closeDropdown() {
    timer = setTimeout(function () {
      return setIsOpen(false);
    }, DROPDOWN_SAFETY_TIMER);
  };

  var handleMouseOver = function handleMouseOver(evt) {
    if (utils_1.windowIsAboveWidth(theme.navbar.collapseAt)) {
      openDropdown(evt);
    }
  };

  var handleMouseLeave = function handleMouseLeave() {
    if (utils_1.windowIsAboveWidth(theme.navbar.collapseAt)) {
      closeDropdown();
    }
  };

  var handleClickToggle = function handleClickToggle(evt) {
    if (!utils_1.windowIsAboveWidth(theme.navbar.collapseAt)) {
      if (!isOpen) {
        openDropdown(evt);
      } else {
        closeDropdown();
      }
    }
  };

  var context = {
    isOpen: isOpen,
    displayLeft: displayLeft
  };
  return core_1.jsx(DropdownWrapper, Object.assign({}, rest, {
    role: "navigation",
    onMouseOver: handleMouseOver,
    onClick: handleClickToggle,
    onMouseLeave: handleMouseLeave,
    onFocus: handleMouseOver,
    onBlur: handleMouseLeave,
    ref: ref,
    css: {
      label: 'navbarDropdown'
    }
  }), core_1.jsx(exports.NavbarDropdownContext.Provider, {
    value: context
  }, toggle(handleMouseOver), children));
});
NavbarDropdown.displayName = 'NavbarDropdown';
exports.default = emotion_theming_1.withTheme(NavbarDropdown);